import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { msal } from './auth/msal'
import { SignInGate } from './auth/SignInGate'
import './styles/tokens.css'

/**
 * MSAL must finish initialising before React renders.
 *
 * initialize() sets up the token cache, and handleRedirectPromise() completes a
 * sign-in that is coming back from Microsoft — the app loads with a code in the
 * URL and has to exchange it. Rendering first means the gate briefly decides the
 * user is signed out and bounces them into a second sign-in.
 */
async function start() {
  await msal.initialize()
  await msal.handleRedirectPromise()

  // Without an active account, silent token acquisition has nothing to refresh
  // against and every request would prompt.
  const accounts = msal.getAllAccounts()
  if (accounts.length > 0 && !msal.getActiveAccount()) {
    msal.setActiveAccount(accounts[0])
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msal}>
        <SignInGate>
          <App />
        </SignInGate>
      </MsalProvider>
    </StrictMode>,
  )
}

void start()
